/** Expanded desktop dropdown height when feed is loading or present. */
export const DESKTOP_DEFAULT_SEARCH_EXPANDED_HEIGHT = "82vh";

/** Desktop-only: curtain/height animation is applied in DesktopSearch, not MobileSearch. */

/** Desktop search dropdown shell (curtain animation target in DesktopSearch). */
export const DESKTOP_SEARCH_DROPDOWN_SHELL_CLASS =
  "fixed max-h-[82vh] overflow-y-auto rounded-b-8 bg-white-900 md:absolute md:left-0 md:top-[4.4rem] md:z-50 md:mt-1 md:w-[700px] xxl:w-[877px]";

/** Smooth resize when feed is absent after load. */
export const DESKTOP_DEFAULT_SEARCH_HEIGHT_TRANSITION = { duration: 0.65, ease: [0.22, 1, 0.36, 1] };

/** Desktop dropdown: slow top-origin curtain unroll. */
export const DESKTOP_DEFAULT_SEARCH_CURTAIN_TRANSITION = { duration: 0.75, ease: [0.22, 1, 0.36, 1] };

/** Minimum compact dropdown height when there is no recent search and no feed. */
export const DESKTOP_DEFAULT_SEARCH_EMPTY_HEIGHT_PX = 24;

/** Hides scrollbar while keeping overflow scroll (default search desktop + mobile). */
export const DEFAULT_SEARCH_HIDDEN_SCROLLBAR_CLASS = "scrollbar-hide";
